import React, { FunctionComponent } from 'react'
import FontelloIcon from '@sport1/react-elements/FontelloIcon'
import Grid from '@sport1/react-elements/Grid'
import Touchable from '@sport1/react-elements/Touchable'
import { TestID } from '../utils/PropTypesDefinitions'
import { NavigationDateFilterProps } from './NavigationDateFilterProps'
import NavigationDate from './Date'

const NavigationDateFilter: FunctionComponent<NavigationDateFilterProps & TestID> = ({
    label,
    onDatePress,
    onRightIconPress,
    onLeftIconPress,
    testID,
}) => (
    <Grid horizontal height={44} backgroundColor="pearl" testID={testID}>
        <Touchable onPress={onLeftIconPress} testID={testID && `${testID}_to_past`}>
            <Grid noExpand paddingLeft={16} centerVertical alignLeft height={44} width={40}>
                <FontelloIcon name="scroll-left" color="onyx" />
            </Grid>
        </Touchable>
        <Grid center>
            <NavigationDate label={label} onDatePress={onDatePress} testID={testID} />
        </Grid>
        <Touchable onPress={onRightIconPress} testID={testID && `${testID}_to_future`}>
            <Grid noExpand paddingRight={16} alignRight centerVertical height={44} width={40}>
                <FontelloIcon name="scroll-right" color="onyx" />
            </Grid>
        </Touchable>
    </Grid>
)

export default NavigationDateFilter
